// components
import { PageTemplate } from '@/pwa/templates/PageTemplate/PageTemplate';
import { PageHeader } from '@/pwa/atoms/PageHeader/PageHeader';
import { HorizontalCard } from '@/pwa/atoms/HorizontalCard/HorizontalCard';

// mui
import { Grid, LinearProgress, Stack, Typography } from '@mui/material';

const Progress = ({ progress }: { progress: number }) => {
  return (
    <Stack
      direction='row'
      spacing={2}
      sx={{
        alignItems: 'center',
        flexGrow: 1,
      }}
    >
      <LinearProgress
        variant='determinate'
        value={progress}
        sx={{ flexGrow: 1 }}
      />
      <Typography variant='caption'>{progress}%</Typography>
    </Stack>
  );
};

export interface ActionsProps {
  title: string;
  description: string;
  categories: {
    id: string;
    title: string;
    progress: number;
    onClick: () => void;
  }[];
  emptySlot?: React.ReactNode;
}

/**
 * Actions is the top-level actions page showing category cards with progress.
 */
export const Actions = ({
  title,
  description,
  categories,
  emptySlot,
}: ActionsProps) => {
  return (
    <PageTemplate
      headerSlot={<PageHeader title={title} description={description} />}
      contentSlot={
        categories.length === 0 && emptySlot ? (
          emptySlot
        ) : (
          <Grid container spacing={2}>
            {categories.map((category) => (
              <Grid size={{ xs: 12, md: 6 }} key={category.id}>
                <HorizontalCard
                  title={category.title}
                  subtitle=''
                  onClick={category.onClick}
                  slot={<Progress progress={category.progress} />}
                />
              </Grid>
            ))}
          </Grid>
        )
      }
    />
  );
};

Actions.displayName = 'Actions';

export default Actions;
